import { Upload } from 'antd'

function ANTDUpload({ ...props }) {
  return <Upload {...props} />
}

export default ANTDUpload
